import React,{ useState } from 'react';
import { getShipsGoData } from '../../../../helpers/mapsHelper';
import './Modal.css';

const Modal = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shipsGo, setShipsGo] = useState('');

  const enableSubscribeBtn =
    data && data?.atd_date && !data?.ata_date && data?.container_code;

  const getTrackingCode = async () => {
    setLoading(true);

    let dataShipsGo = null;

    try {
      dataShipsGo = await getShipsGoData({
        container_number: data?.container_code.toString().replace(/-/g, ''),
        uuid_po_item: data?.uuid,
      });

    } catch (err) {
      console.error('Erro ao buscar localizações:', err);
    } finally {
      setLoading(false);
      if (dataShipsGo?.type === 'shipsgo') {
        setShipsGo(dataShipsGo.tracking.trackingCode);
        setIsOpen(false);
        window.location.reload();
      } else {
        setShipsGo('error');
      }
    }
  };

  return (
    <>
      {enableSubscribeBtn && (
        <div className="btn btn-map" onClick={() => setIsOpen(true)}>
          Sobrescrever
        </div>
      )}

      {isOpen && (
        <div className="modal-overlay-map">
          {shipsGo != 'error' && (
            <div className="modal-box-map">
              <button className="modal-close-map" onClick={() => setIsOpen(false)}>
                ×
              </button>
              <p className="modal-message-tracking-map">
                Você deseja realmente sobrescrever?
              </p>

              <div className="modal-content-button-map">
                <button
                  className="btn-get-tracking-map"
                  onClick={() => {
                    getTrackingCode();
                  }}
                >
                  {loading ? 'Sobrescrevendo...' : 'Sim'}
                </button>
                <button
                  className="btn-close-tracking-map"
                  onClick={() => setIsOpen(false)}
                >
                  Não
                </button>
              </div>
            </div>
          )}

          {shipsGo === 'error' && (
            <div className="modal-box-map">
              <button className="modal-close-map" onClick={() => { setIsOpen(false); setShipsGo('')}}>
                ×
              </button>
              <p className="modal-message-tracking-map">
                Nenhum resultado encontrado para o container
              </p>
              <div className="modal-content-button-map">
                <button
                  className="btn-close-tracking-map"
                  onClick={() => { setIsOpen(false); setShipsGo('')}}
                >
                  Fechar
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Modal;
